import { Network } from '@/utils/network'

import urls from '../urls.json'

async function getRawProductsDetails(ids) {
  const response = await sendRequest(ids)
  const parsedResponse = parseResponse(response)
  return parsedResponse
}

async function sendRequest(ids) {
  const url = urls.proxyRequestSimultaneous
  const data = {
    requests: ids.map(id => {
      return {
        method: 'get',
        id,
        url: `${urls.getProductDetails}${id}`,
      }
    }),
  }
  const response = await Network.sendPostRequest(url, data)

  return response
}

function parseResponse(response) {
  if (response && response.status.code === 200) {
    return {
      statusCode: 200,
      data: Object.values(response?.response)
        .map(res => {
          return res?.body?.statusCode == 200 ? res.body.data : null
        })
        .filter(el => !!el),
    }
  }
  return {
    statusCode: 404,
    message: 'products not found',
  }
}

export { getRawProductsDetails }
